import {Params} from '@feathersjs/feathers'

import {ProviderInfoOption} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'providerInfoOption'

const get = async (params?: Params) => feathersService.find<ProviderInfoOption>(RESOURCE, params)

export const getById = async (payload: ProviderInfoOption) => {
  const params = {
    query: {
      providerInfoId: payload.providerInfoId,
      optionId: payload.optionId,
    },
  }
  return get(params)
}

export const create = async (payload: ProviderInfoOption) =>
  feathersService.create<ProviderInfoOption, ProviderInfoOption>(RESOURCE, payload)

export const remove = async (payload: ProviderInfoOption) =>
  feathersService.remove<ProviderInfoOption>(
    RESOURCE,
    `${payload.providerInfoId},${payload.optionId}`
  )
